/**
 * Control the location boundary map rendering
 * @param map  an instance of BingMaps.Map
 */
define(['bing', 'jquery'], function (BingMaps, $) {
   "use strict";

   return function (map) {
      var self = this,

         m_polylayer = new BingMaps.Layer(),
         m_aShapes = [],
         m_map = map,

         /**
          * Draw a polygon to the map with the specified coordinates and color
          * @param aLocation
          * @param polygonColor
          */
         drawPolygon = function (aLocation, polygonColor, strLocationName) {
            var fillOpa = 0.2,
               polygonFillColor = new BingMaps.Color.fromHex(polygonColor),
               polygonStrokeColor = new BingMaps.Color.fromHex("#ff0000");

            polygonFillColor.a = fillOpa;
            polygonStrokeColor.a = 0;

            var poly = new BingMaps.Polygon(aLocation, {
               fillColor: polygonFillColor,
               strokeColor: polygonStrokeColor,
               strokeThickness: 0
            });

            // Add the shape to the map
            m_polylayer.add(poly);
            m_aShapes.push(poly);
         },

         initialize = function () {
            m_map.layers.insert(m_polylayer);
         };

      initialize();

      self.addMapLocation = function (aLocation, strLocationName) {
         var color = "#003040";
         drawPolygon(aLocation, color, strLocationName);
      };

      self.clearLocationBoundaryMap = function () {
         $.each(m_aShapes, function (i, shape) {
            m_polylayer.remove(shape);
         });
      };
   };
});
